const slugify = (value = "") => (
	value
		.toString()
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.replace(/[^a-zA-Z0-9\s-]/g, "")
		.trim()
		.replace(/[\s-]+/g, "-")
		.toLowerCase()
);

const resolveRailwaysList = data => {
	if (!data) return [];
	if (Array.isArray(data)) return data;
	if (Array.isArray(data.objects)) return data.objects;
	return [];
};

const resolveRailwayMediaUrl = value => {
	if (!value) return "";
	const normalizedValue = String(value).trim();
	if (normalizedValue.startsWith("http")) return normalizedValue;
	if (normalizedValue.startsWith("//")) return `https:${normalizedValue}`;
	const sanitizedValue = normalizedValue.replace(/^\.\//, "");
	const normalizedPath = sanitizedValue.startsWith("/") ? sanitizedValue : `/${sanitizedValue}`;
	return `https://www.heritage-ops.org.uk${normalizedPath}`;
};

const resolveRailwayType = railway => (
	railway?.Type?.Name || ""
);

const resolveRailwayTypeColor = railway => (
	railway?.Type?.Colour || "#9acce7"
);

const resolveExternalUrl = value => {
	if (!value) return "";
	const normalizedValue = String(value).trim();
	if (!normalizedValue) return "";
	if (normalizedValue.startsWith("//")) return `https:${normalizedValue}`;
	if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(normalizedValue)) return normalizedValue;
	return `https://${normalizedValue}`;
};

const resolveRailwayLocation = railway => {
	const address = railway?.Address;
	if (!address) return "";
	const parts = [address.City, address.County, address.Country]
		.filter(Boolean);
	return parts.join(", ");
};

const formatDistanceMilesKm = distanceMiles => {
	if ((typeof distanceMiles !== "number") || Number.isNaN(distanceMiles)) return "";
	const km = distanceMiles * 1.609344;
	return `${distanceMiles.toFixed(1)} miles (${km.toFixed(1)} km) away`;
};

export {
	slugify,
	resolveRailwaysList,
	resolveRailwayMediaUrl,
	resolveRailwayType,
	resolveRailwayTypeColor,
	resolveExternalUrl,
	resolveRailwayLocation,
	formatDistanceMilesKm
};
